import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddSound = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_875_51246",
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0H20V20H0V0Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_875_51246)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11 4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4V9H4C3.44772 9 3 9.44772 3 10C3 10.5523 3.44772 11 4 11H9V16C9 16.5523 9.44771 17 10 17C10.5523 17 11 16.5523 11 16V11H16C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9H11V4Z",
				fill: "#7683A8"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgAddSound);
export default ForwardRef;
